module.exports = __webpack_public_path__ + "img/btn_google@3x@2x.e44f0db8.png";